import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { mobiIcon } from '@mobi/rwc-utils-icons-jslib';

@Component({
  standalone: false,
  selector: 'webform-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss'],
})
export class ContainerComponent implements OnInit {
  @Output() onSubmit: EventEmitter<void> = new EventEmitter<void>();
  @Input() field!: any;
  @Input() parentGroup!: FormGroup;
  @Input() submit!: Function;

  id!: string;
  type!: string;
  icon!: mobiIcon;
  box!: boolean;
  background!: string;
  parentKey!: string;

  ngOnInit(): void {
    this.id = this.field['#webform_id'];
    this.type = this.field['#type'] || 'container';
    this.icon = this.field['#icon'] || null;
    this.box = this.field['#box'] || false;
    this.background = this.field['#background'];
    this.parentKey = this.field['#webform_parent_key'];
  }
  /**
   * Get all the subfields of a container
   * @param container
   */
  getContainerSubfields(container: any): any[] {
    const containerSubfields: any[] = [];

    Object.keys(container).forEach((key: string) => {
      if (!key.includes('#')) containerSubfields.push(container[key]);
    });

    return containerSubfields;
  }
}
